var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-3",attrs:{"id":"chart"}},[_c('p',{staticClass:"headline mb-1 text--primary"},[_vm._v(" Duração da Falha ")]),_c('apexcharts',{attrs:{"type":"bar","height":"350","options":_vm.chartOptions,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }